export class Connection {
  public id!: string;
  public name = '';
  public display_name = '';
  public strategy = '';
  public domain = '';
  public client_id = '';
  public client_secret = '';
  public enabled_clients: string[] = [];
  public connection_type!: number; // 1 for Auth0, 2 for DH User
  public available_in_auth0!: boolean;
  public hide = false;
}

export class Auth0Client {
  public client_id!: string;
  public name = '';
}
